import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { unwrappedNavigationPlayerIdAtom } from '@/atoms/navigation';
import { classicUrl } from '@/utils/classicLinks';

export const usePlayerNavigationItems = () => {
  const { t } = useTranslation(['navigation']);
  const iqPlayerId = useAtomValue(unwrappedNavigationPlayerIdAtom).iqId;
  const basePlayerPath = classicUrl(`player/${iqPlayerId}`);

  return [
    {
      id: 'player-dashboard',
      label: t('crossPlatform.secondary.dashboard'),
      route: `${basePlayerPath}/dashboard`,
    },
    {
      id: 'player-radar',
      label: t('crossPlatform.secondary.radar'),
      route: `${basePlayerPath}/radar`,
    },
    {
      id: 'player-key-passes',
      label: t('crossPlatform.secondary.keyPasses'),
      route: classicUrl(`_/player/key-passes?playerId=${iqPlayerId}`),
    },
    {
      id: 'player-shot-map',
      label: t('crossPlatform.secondary.shotMap'),
      route: `${basePlayerPath}/shots`,
    },
    {
      id: 'player-shot-distribution',
      label: t('crossPlatform.secondary.shotDistribution'),
      route: `${basePlayerPath}/dot-histogram`,
    },
    {
      id: 'player-defensive-activity',
      label: t('crossPlatform.secondary.defensiveActivity'),
      route: `${basePlayerPath}/defensive-activity`,
    },
    {
      id: 'player-minutes-played',
      label: t('crossPlatform.secondary.minutesPlayed'),
      route: `${basePlayerPath}/minutes-played`,
    },
    {
      id: 'player-similar-players',
      label: t('crossPlatform.secondary.similarPlayers'),
      route: `${basePlayerPath}/similar`,
    },
    {
      id: 'player-positions-played',
      label: t('crossPlatform.secondary.positionsPlayed'),
      route: `${basePlayerPath}/player-position`,
    },
  ];
};
